import { AcrossDeposit, AcrossTermCondition } from '@/types/across'

import { AbiCoder, BytesLike } from 'ethers'

const abiCoder = AbiCoder.defaultAbiCoder()

export const getAcrossMetadata = (deposit: AcrossDeposit, term: AcrossTermCondition): BytesLike => {
  const metadata: BytesLike = abiCoder.encode(
    [
      'tuple(uint256,address,uint256,tuple(address,uint256,address),bytes[3])',
      'tuple(address,address,address,address,uint64)',
    ],
    [
      [deposit.sessionId, deposit.solver, deposit.amountIn, Object.values(deposit.from), deposit.to],
      Object.values(term),
    ]
  )
  return metadata
}

export const getAcrossMsg = (metadata: BytesLike, userAuthSig: BytesLike, optimexAuthSig: BytesLike): BytesLike => {
  const msg: BytesLike = abiCoder.encode(['bytes', 'bytes', 'bytes'], [metadata, userAuthSig, optimexAuthSig])

  return msg
}
